import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  InputSignalWithTransform,
  ModelSignal,
  OutputEmitterRef,
  input,
  model,
  output,
} from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

type IndexReorderEvent = {
  previousIndex: number;
  currentIndex: number;
};

@Component({
  selector: 'mp-drag-handle',
  templateUrl: './drag-handle.component.html',
  styleUrl: './drag-handle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatFormFieldModule, MatInputModule],
})
export class DragHandleComponent {
  readonly invertArrowKeys: InputSignalWithTransform<boolean, BooleanInput> = input<boolean, BooleanInput>(false, {
    transform: coerceBooleanProperty,
  });

  readonly showIndexInput: InputSignalWithTransform<boolean, BooleanInput> = input<boolean, BooleanInput>(false, {
    transform: coerceBooleanProperty,
  });

  readonly index: ModelSignal<number> = model.required<number>();

  readonly minIndex: InputSignal<number> = input<number>(1);
  readonly maxIndex: InputSignal<number | undefined> = input<number>();

  readonly itemReorder: OutputEmitterRef<IndexReorderEvent> = output<IndexReorderEvent>();

  handleArrowKey(key: 'up' | 'down'): void {
    const previousIndex: number = this.index();
    const direction: number = (key === 'up' ? -1 : 1) * (this.invertArrowKeys() ? -1 : 1);
    const currentIndex: number = previousIndex + direction;

    this.index.set(currentIndex);

    this.itemReorder.emit({ previousIndex, currentIndex });
  }

  handleIndexChange(currentIndex: number): void {
    const previousIndex: number = this.index();

    this.index.set(currentIndex);

    this.itemReorder.emit({ previousIndex, currentIndex });
  }
}
